/** Shared pricing plans — home + /pricing page */
export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    icon: 'fas fa-rocket',
    tagline: 'Launch fast',
    price: '₹25,000',
    period: '/ project',
    features: [
      'Landing page design',
      'Mobile responsive',
      'Basic SEO setup',
      '2 revision rounds',
      '14-day delivery',
    ],
    featured: false,
  },
  {
    id: 'business',
    name: 'Business',
    icon: 'fas fa-briefcase',
    tagline: 'Grow online',
    price: '₹75,000',
    period: '/ project',
    features: [
      'Multi-page website',
      'CMS integration',
      'Advanced SEO',
      '5 revision rounds',
      'CRM-ready structure',
      '30-day support',
    ],
    featured: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    icon: 'fas fa-building',
    tagline: 'Scale without limits',
    price: 'Custom',
    period: '',
    features: [
      'CRM / ERP systems',
      'E-commerce platform',
      'API integrations',
      'Dedicated dev team',
      'Priority support SLA',
    ],
    featured: false,
  },
];

export const pricingIncludes = [
  { icon: 'fas fa-shield-alt', label: 'Secure hosting guidance' },
  { icon: 'fas fa-headset', label: 'Dedicated support' },
  { icon: 'fas fa-file-invoice', label: 'Transparent quotes' },
  { icon: 'fas fa-globe', label: 'India & UK clients' },
];
